const axios = require('axios');
const apiUrl = process.env.REACT_APP_API_URL;
const yaCounter = 64504303;

export interface NpsData {
  id: string;
  question: string;
  llabel: string;
  rlabel: string;
  user_name: string;
  user_id: string;
}

interface GetNpsResponse {
  status: number;
  data: NpsData;
}

export default {
  async getNps(hash: string): Promise<GetNpsResponse> {
    const url = `${apiUrl}online/interview/hashed/${hash}`;
    const res = await axios.get(url);
    return res.data;
  },

  async postNpsRate(rate: number, hash: string, comment?: string) {
    const url = `${apiUrl}online/interview/hashed`;
    const data = {
      data: {
        hash,
        iid: 1,
        ivalue: rate,
        comment
      },
    };
    const options = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const res = await axios.post(url, data, options);

    if (process.env.NODE_ENV === 'production') {
      // @ts-ignore
      const tracker = ga.getAll()[0];
      tracker.send('event', 'button', 'done', 'nps');

      // @ts-ignore
      ym(64504303,'reachGoal','nps_done')
    }

    return res.data;
  },

  async getUserData(userId: number) {
    const url = `${apiUrl}public/users/metrika/${userId}`;
    const res = await axios(url);
    return res.data.data[0];
  },

  addUserYaMetrics(data: object) {
    if (process.env.NODE_ENV !== 'production') {
      return;
    }
    // @ts-ignore
    ym(yaCounter, 'userParams', data);
  },

  addVisitYaParams(data: object) {
    if (process.env.NODE_ENV !== 'production') {
      return;
    }
    // @ts-ignore
    ym(yaCounter, 'params', data);
  }
};
